export default "__VITE_ASSET__EqzBIwSW__"